import { useQuery } from '@tanstack/react-query';
import { operationApis } from '../../../../../../../shared/apis/operation/apis';

export function usePopupItem({
  queryKey,
  payload,
  enabled,
}: {
  queryKey: string[];
  payload: { popupId: number };
  enabled: boolean;
}) {
  const { data: popupItem } = useQuery(queryKey, () => operationApis.getPopupDetail(payload.popupId), {
    enabled,
    select: (data) => data.data.result[0],
  });

  return { popupItem };
}
